import { saveAnnotationOrder } from '../../annotations/annotationStore';

/**
 * Up / down handlers for each word of `list` (one subtitle's words, in
 * order): { [id]: { up, down } }, null at either end. A move shows at once
 * (onUpdated for each word) and is put back if it can't be saved.
 */
export function reorderHandlers(list, onUpdated) {
  const move = (from, to) => async () => {
    const next = [...list];
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    const placed = next.map((a, order) => ({ ...a, order }));
    placed.forEach((a) => onUpdated && onUpdated(a));
    try {
      await saveAnnotationOrder(next);
    } catch (e) {
      console.error('Error saving the order of the words:', e);
      list.forEach((a) => onUpdated && onUpdated(a));
    }
  };
  return Object.fromEntries(list.map((a, i) => [a.id, {
    up: i > 0 ? move(i, i - 1) : null,
    down: i < list.length - 1 ? move(i, i + 1) : null,
  }]));
}
